// axiosInstance.js
import axios, { AxiosError } from 'axios';
import { BAD_REQUEST_STATUS_CODE } from './constants';
import { notification } from 'antd/lib';
import { APP_TERMS } from '../app-terms';
const fileUploadApi = axios.create({
    timeout: 600000, // add 10 minutes timeout for large file uploads
});

fileUploadApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (
            error instanceof AxiosError &&
            error?.response?.status === BAD_REQUEST_STATUS_CODE
        ) {
            // To check if error available on data, if yes then notify user with it
            if (error?.response?.data?.error) {
                notification.error({
                    message: APP_TERMS.error_title,
                    description: error.response.data?.error,
                    showProgress: false,
                });
            } else if (error.response.data?.message) {
                // else notify user with message on data
                notification.error({
                    message: APP_TERMS.error_title,
                    description: error.response.data?.message,
                    showProgress: false,
                });
            }
        }
        return Promise.reject(error);
    }
);

export default fileUploadApi;
